import { DateTime } from 'luxon'


export default function prepareAppDate(dateString: string | null): string {
  if(dateString === null) {
    return ''
  }
  const parsedDate = DateTime.fromISO(dateString)
  return parsedDate.toFormat('MMMM d, yyyy')
}
